<p>
    Don't Fall! is a competitive two player rag-doll game. Push and throw the
    enemy off the platform. Don't fall! There's also a single player survival
    challenge.
</p>

<p>
    Don't Fall! was originally made over the course of a weekend. It reached
    over a million plays on the Chrome Web Store, Scirra Arcade, and a defunct site called Clay.io.
</p>
